import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './container/auth.component';
import { AuthGuard } from './shared/auth.guard';
import { AuthGuestGuard } from './shared/auth-guest.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        canActivate: [AuthGuestGuard],
        loadChildren: () =>
          import('../+login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'companies',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('../+companies/companies.module').then(
            ({ CompaniesModule }) => CompaniesModule
          ),
      },
      {
        path: 'password',
        loadChildren: () =>
          import('../+password/password.module').then(
            ({ PasswordModule }) => PasswordModule
          ),
      },
      {
        path: 'new-account',
        loadChildren: () =>
          import('../+new-account/new-account.module').then(
            ({ NewAccountModule }) => NewAccountModule
          ),
      },
      {
        path: 'email',
        loadChildren: () =>
          import('../+email-confirmation/email-confirmation.module').then(
            ({ EmailConfirmationModule }) => EmailConfirmationModule
          ),
      },
      {
        path: 'logout',
        loadChildren: () =>
          import('../+logout/logout.module').then(({ LogoutModule }) => LogoutModule),

      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: '/login',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
